
import surveying from "@/urls/roles/surveying";

import {
    sendGetRequest,
    sendPostRequest,
    sendPatchRequest,
    sendPostRequestFile
} from "@/helper/requests";

const state = {

}

const getters = {

}

const mutations = {
    set_survey: (state, data) => {
      /**
       * Устанавливает список опросов
       */
        state.surveys = data
    },
    set_survey_data:  (state, data) => {
      /**
       * Устанавливает детальную информацию об опросе
       */
        state.survey_detail = data
    },
}

const actions = {
    createAttempt: ({commit}, {data, key = null, finalizer, catcher}) => {
      /**
       * Создает новую попытку прохождения опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} data - Данные для создания попытки
       * @param {string} key - Ключ специальной ссылки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let get = {}
        if (key) get['special_link_key'] = key
        sendPostRequest(
          surveying.SURVEYING.ATTEMPT.CREATE(key, get),
          data,
          finalizer ? finalizer : () => {},
          catcher ? catcher : () => {},
        )
    },
    CheckAttempt: ({commit}, {survey_id, email=undefined, key = null, token=null, finalizer, catcher}) => {
      /**
       * Проверяет возможность создания попытки для опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {string} email - Email пользователя для проверки
       * @param {string} key - Ключ специальной ссылки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let get = {}
        if (email) get['email'] = email
        if (key) get['special_link_key'] = key
        if (token) get['token'] = token
      sendGetRequest(
            surveying.SURVEYING.ATTEMPT.CHECK(survey_id, get),
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    endAttempt: ({commit}, {id, data, finalizer, catcher}) => {
      /**
       * Завершает попытку прохождения опроса
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор попытки
       * @param {Object} data - Данные для завершения
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        sendPatchRequest(
            surveying.SURVEYING.ATTEMPT.END(id),
            data,
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    LoadSurveys: ({commit}, {url,finalizer, catcher}) => {
      /**
       * Загружает список доступных опросов
       * @param {Function} commit - Функция для вызова мутаций
       * @param {string} url - URL для запроса
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        if (!url){
            url = surveying.SURVEYING.SURVEY.LIST();
        }
        sendGetRequest(
            url,
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    LoadSurveyDetail: ({commit}, {survey_id, key = null, finalizer, catcher}) => {
      /**
       * Загружает детальную информацию об опросе
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} survey_id - Идентификатор опроса
       * @param {string} key - Ключ специальной ссылки
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let get = {}
        if (key) get['special_link_key'] = key
        sendGetRequest(
            surveying.SURVEYING.SURVEY.DETAIL(survey_id, get),
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    StageList: ({commit}, {attempt_id, attempt_hash, finalizer, catcher}) => {
      /**
       * Загружает список этапов для попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} attempt_id - Идентификатор попытки
       * @param {string} attempt_hash - Хэш попытки для дополнительной безопасности
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let get = {'size': 100}
        if (attempt_hash) get['attempt_hash'] = attempt_hash
        sendGetRequest(
            surveying.SURVEYING.ATTEMPT.STAGE_LIST(attempt_id, get),
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    StageFieldList: ({commit}, {attempt_id, attempt_hash, stage_id, finalizer, catcher}) => {
      /**
       * Загружает поля конкретного этапа попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} attempt_id - Идентификатор попытки
       * @param {string} attempt_hash - Хэш попытки для дополнительной безопасности
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let get = {'size': 100}
        if (attempt_hash) get['attempt_hash'] = attempt_hash
        sendGetRequest(
            surveying.SURVEYING.ATTEMPT.FIELD_LIST(attempt_id, stage_id, get),
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    SurveyingSave: ({commit}, {attempt_id, stage_id, data, finalizer, catcher}) => {
      /**
       * Сохраняет ответы для этапа попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} params.attempt_id - Идентификатор попытки
       * @param {number} params.stage_id - Идентификатор этапа
       * @param {Object|FormData} data - Данные ответов
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        sendPostRequestFile(
            surveying.SURVEYING.ATTEMPT.STAGE_SAVE(attempt_id, stage_id),
            data,
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },
    SaveAnswerList: ({commit}, {attempt_id, stage_id, finalizer, catcher}) => {
      /**
       * Загружает сохраненные ответы для этапа попытки
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Object} params - Параметры запроса
       * @param {number} attempt_id - Идентификатор попытки
       * @param {number} stage_id - Идентификатор этапа
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function}catcher - Функция-обработчик ошибок
       */
        sendGetRequest(
            surveying.SURVEYING.ATTEMPT.ANSWER_LIST(attempt_id, stage_id),
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    },

}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
